import { PAYMENT_SWITCH_HASH_LINKS, STORE_NAME } from '@intigral/constant';
import { get } from '../browser-storage/localStorage';
import { isBrowser } from './browser';

/**
 * Checks whether the logged-in user is in an active grace period.
 * Reads the user object from local storage.
 * @returns true when tierStatus.isGracePeriod is true and graceInfo is not null.
 */
export const isUserInGracePeriod = (): boolean => {
    const user = get(STORE_NAME.USER);
    return Boolean(user?.tierStatus?.isGracePeriod && user?.tierStatus?.graceInfo != null);
};

/**
 * Redirects the user to the account payment selection page.
 * @param myAccountUrlTemplate - `externalLinks.myAccount` from configuration.
 * @param language - Current language code (e.g. `en`, `ar`).
 */
export const redirectToPaymentSelectionPage = (myAccountUrlTemplate: string, language: string): void => {
    if (!myAccountUrlTemplate || !language || !isBrowser()) {
        return;
    }

    const accountUrl =
        (language === 'en'
            ? myAccountUrlTemplate.replace('{LANG}', language)
            : myAccountUrlTemplate.replace('{LANG}/', '')) +
        `#${PAYMENT_SWITCH_HASH_LINKS.PAYMENT_METHOD_SELECTION}`;
    window.location.replace(accountUrl);
};
